// SCD-402: editors upload high-resolution images for display ads, so the image
// dropzones take files up to 10 MB. The editor's backend checks the same bound
// (AdApiController::updateThirdPartyCreative).
export const MAX_IMAGE_UPLOAD_SIZE = 10 * 1024 ** 2;

// react-dropzone's own message reads "File is larger than 10485760 bytes";
// a too-large file is reported with the limit in MB instead.
export const readableUploadErrors = (errors, maxSize, t) => errors.map((error) => (
    error.code === 'file-too-large'
        ? { ...error, message: t('upload.fileTooLarge', { size: +(maxSize / 1024 ** 2).toFixed(1) }) }
        : error
));
